import { localToday, ruDateTime } from '../../lib/format';

/*
 * Время на карточках 006 — по времени объекта (дизайн-система, «Тексты»: `чч:мм` по местному времени объекта):
 * сегодня — «14:05», раньше — «17.10.2026 14:05»; время проверки агента — с секундами, «15:42:07».
 */

const OFFSET = /^([+-])(\d{2}):(\d{2})$/;

function offsetMs(tz: string): number {
  const m = OFFSET.exec(tz);
  return m ? (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) * 60_000 : 0;
}

/** «14:05», если сегодня по времени объекта, иначе «17.10.2026 14:05». Нет времени — «—». */
export function sinceText(iso: string | null, tz: string, now = Date.now()): string {
  if (!iso || !Number.isFinite(Date.parse(iso))) return '—';
  const full = ruDateTime(iso, tz); // «дд.мм.гггг чч:мм»
  const today = localToday(tz, now); // «гггг-мм-дд»
  const date = `${full.slice(6, 10)}-${full.slice(3, 5)}-${full.slice(0, 2)}`;
  return date === today ? full.slice(11, 16) : full;
}

/** «15:42:07» по времени объекта. */
export function clockSeconds(iso: string, tz: string): string {
  const ms = Date.parse(iso);
  if (!Number.isFinite(ms)) return '';
  return new Date(ms + offsetMs(tz)).toISOString().slice(11, 19);
}
